import styled, { css } from 'styled-components'
import tw from 'twin.macro'

const columns = ({ $columns }) => {
  if ($columns === 1) {
    return tw`grid-cols-1`
  }

  if ($columns === 2) {
    return tw`grid-cols-1 md:grid-cols-2`
  }

  return tw`grid-cols-1`
}

const align = ({ $align }) => {
  if ($align === 'center') {
    return tw`justify-items-center`
  }

  if ($align === 'left') {
    return tw`justify-items-center md:justify-items-start`
  }

  if ($align === 'right') {
    return tw`justify-items-center md:justify-items-end`
  }
}

const valign = ({ $valign }) => {
  if ($valign === 'center') {
    return tw`md:items-center`
  }

  if ($valign === 'top') {
    return tw`md:items-start`
  }

  if ($valign === 'bottom') {
    return tw`md:items-end`
  }
}

const bg = ({ $bg }) => {
  if ($bg) {
    return css`
      background-image: url(${$bg});
      background-position: center;
      background-size: cover;
    `
  }
}

export const Root = styled.div`
  ${tw`mx-auto max-w-watchesMaxFlush min-h-[677px] grid items-center`};
  ${bg};
`

export const Main = styled.div`
  ${tw`mx-auto  py-20 px-12 sm:px-24 grid gap-x-16 lg:gap-x-20 gap-y-12`};
  ${columns};
  ${align};
  ${valign};
`

export const Child = styled.div`
  ${tw`w-full flex items-center justify-center`};
  max-width: 30rem;
`
